import * as styles from "./DialogBackdrop.css";

import type { JSX } from "react";

import { Dialog as BaseDialog } from "@base-ui/react/dialog";

import type { DialogBackdropProps } from "./Dialog.types";

export function DialogBackdrop({ ...props }: DialogBackdropProps): JSX.Element {
  return (
    <BaseDialog.Backdrop
      data-slot="dialog-backdrop"
      className={styles.backdrop}
      {...props}
    />
  );
}
